export class DateUtils {
    
    static formatToISO(date: Date): string {
        if (!date) return '';
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    static formatDisplayDate(dateStr: string): string {
        if (!dateStr) return '';
        const date = new Date(dateStr);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    }

    static getMonthsInDateRange(startDate: Date, endDate: Date): { monthNumber: number; year: number }[] {
        if (!startDate || !endDate) {
            const currentYear = new Date().getFullYear();
            return Array.from({ length: 12 }, (_, i) => ({ monthNumber: i + 1, year: currentYear }));
        }

        const months: { monthNumber: number; year: number }[] = [];
        const start = new Date(startDate);
        const end = new Date(endDate);
        const currentMonth = new Date(start.getFullYear(), start.getMonth(), 1);
        const endMonth = new Date(end.getFullYear(), end.getMonth(), 1);

        while (currentMonth <= endMonth) {
            months.push({ 
                monthNumber: currentMonth.getMonth() + 1, 
                year: currentMonth.getFullYear() 
            });
            currentMonth.setMonth(currentMonth.getMonth() + 1);
        }
        return months;
    }

    static getMonthLabelWithYear(monthNumber: number, year: number): string {
        const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
            'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        return `${monthNames[monthNumber - 1] || ''} ${year}`;
    }
}